// extracted by mini-css-extract-plugin
export default {"card":"MalfunctionCard_card__zaXU2","header":"MalfunctionCard_header__b7W0Y","details":"MalfunctionCard_details__-sHRl","actions":"MalfunctionCard_actions__0+QKt"};